import types from '../../realEstateTypes.js';

const stylingProfile = {
  overview_page: {
    wrapper: '',
    formWrapper: 'grid-item one-whole padding-top-m padding-bottom-s grid-flex grid-justify-center',
    buttonWrapper: 'grid grid-flex one-whole grid-justify-end grid-align-end',
    buttonText: 'Kostenlos Preis ermitteln',
  },
  pricedevelopment_desktop_and_tablet: {
    buttonWrapper: {
      [types.HOUSE_BUY]: '',
      [types.HOUSE_RENT]: '',
      [types.APARTMENT_BUY]: '',
      [types.APARTMENT_RENT]: '',
    },
    buttonText: {
      [types.HOUSE_BUY]: 'Preis ermitteln und verfolgen',
      [types.HOUSE_RENT]: 'Preis ermitteln',
      [types.APARTMENT_BUY]: 'Preis ermitteln und verfolgen',
      [types.APARTMENT_RENT]: 'Preis ermitteln',
    },
    buttonHeading: {
      [types.HOUSE_BUY]: '',
      [types.APARTMENT_BUY]: '',
    },
  },
  pricedevelopment_mobile: {
    buttonText: {
      [types.HOUSE_BUY]: 'Preis ermitteln und verfolgen',
      [types.HOUSE_RENT]: 'Preis ermitteln',
      [types.APARTMENT_BUY]: 'Preis ermitteln und verfolgen',
      [types.APARTMENT_RENT]: 'Preis ermitteln',
    },
  },
};

export const profileTypes = {
  OVERVIEW_PAGE: 'overview_page',
  PRICEDEVELOPMENT_DESKTOP_AND_TABLET: 'pricedevelopment_desktop_and_tablet',
  PRICEDEVELOPMENT_MOBILE: 'pricedevelopment_mobile',
};

export const getProfile = (profileType) => stylingProfile[profileType];
